<template>
<div class="chapter">
<div class="inner_page">
<p class="dedi">TO</p>
<p class="dedi1">JOSEPH THOMPSON SHAW</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 02_Dedication.vue?91ab1e58